import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IAppServiceLanguages } from '@app/app.interface';
import { AppService } from '@app/app.service';
import { AppHelper } from '@app/core/app.helper';
import { NotifierService } from '@services/notifier.service';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
    selector: 'app-filter-dialogs',
    templateUrl: './filter-dialogs.component.html',
})
export class FilterDialogsComponent implements OnInit {
    /** Объект формы */
    form: FormGroup = null;
    /** Ссылка на объект формы */
    @ViewChild('formRef', { static: true }) formRef: ElementRef;
    /** Текущий язык формы*/
    currentLangForm: IAppServiceLanguages = {};
    /** Список мультиязычных полей форм */
    readonly #languageFormFields = [{ name: 'title', required: true }];

    constructor(
        private formBuilder: FormBuilder,
        public appService: AppService,
        public notifier: NotifierService,
        public spinner: NgxSpinnerService,
        public dialogRef: MatDialogRef<FilterDialogsComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            title: string;
            id: number;
            data: any;
        },
    ) {
        this.currentLangForm = AppHelper.getCurrentLanguage(this.appService);
    }

    /**
     * Событие окончания инициализации компонента
     */
    ngOnInit() {
        this.initForm(this.data.data);
    }

    /**
     * Установить язык ввода
     * @param lang объект языка
     */
    setCurrentLangForm(lang: IAppServiceLanguages) {
        this.currentLangForm = lang;
    }

    /**
     * Инициализация формы
     */
    initForm(data: any) {
        this.form = this.formBuilder.group({});
        this.#languageFormFields.forEach((field) => {
            const formGroup = this.formBuilder.group({});
            this.form.addControl(field.name, formGroup);
            AppHelper.createLangField(this.appService, this.formBuilder, formGroup, field.name, data, field.required);
        });
        setTimeout(() => {
            AppHelper.focusInput(this.formRef.nativeElement.querySelector('.mat-form-field'));
        }, 0);
    }

    /**
     * Обработка события нажатия на Enter
     * @param {object} event объект события
     */
    keyDownFunction(event): void {
        if (event.code == 'Enter') {
            this.save();
        }
    }

    /**
     * Сохранение данных
     */
    save() {
        if (this.form.valid) {
            const data = Object.assign({}, this.form.value);
            this.dialogRef.close({
                save: true,
                title: data.title,
            });
        } else {
            AppHelper.validateAllFormFields(this.form);
            setTimeout(() => {
                const target = this.formRef.nativeElement.querySelector(
                    '.mat-select.ng-invalid, .mat-input-element.ng-invalid, .mat-checkbox-input.ng-invalid',
                );
                AppHelper.focusInput(target);
            }, 0);
        }
    }

    /**
     * закрытие диалога
     */
    close() {
        this.dialogRef.close({ save: false });
    }
}
